import CryptoJS from 'crypto-js';

export function decrypt(encryptedTextWithIv: string, secretKey: string): string {
    try {
        // Extract IV (first 32 hex chars = 16 bytes)
        const ivHex = encryptedTextWithIv.substring(0, 32);
        const encryptedHex = encryptedTextWithIv.substring(32);

        const iv = CryptoJS.enc.Hex.parse(ivHex);
        const encrypted = CryptoJS.enc.Hex.parse(encryptedHex);
        const encryptedBase64 = CryptoJS.enc.Base64.stringify(encrypted);

        // Hash the secret key using SHA256 and take first 32 characters from base64
        const hashed = CryptoJS.SHA256(secretKey);
        const keyBase64 = CryptoJS.enc.Base64.stringify(hashed).substring(0, 32);
        const key = CryptoJS.enc.Utf8.parse(keyBase64);

        // Decrypt
        const decrypted = CryptoJS.AES.decrypt(encryptedBase64, key, {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (e) {
        console.error('Decryption failed:', e);
        return '';
    }
}
